export const VUEX_FLAG = {
  SET_ACCOUNT_LOGIN_USER: "SET_ACCOUNT_LOGIN_USER",
  SET_ACCOUNT_PERIOD: "SET_ACCOUNT_PERIOD",
  SET_ACCOUNT_COMPANY: "SET_ACCOUNT_COMPANY",
  SET_ACCOUNT_INVOICEMSG: "SET_ACCOUNT_INVOICEMSG",
  SET_ACCOUNT_PERIOD_FLAG: "SET_ACCOUNT_PERIOD_FLAG",
  SHOW_CONFIRM_ACCOUNT_COMPANY: "SHOW_CONFIRM_ACCOUNT_COMPANY",
};



// WEBPACK FOOTER //
// ./src/store/flag.js